import Login from '@/views/auth/Login'
import RegistrarSenha from '@/views/auth/RegistrarSenha'

const routes = [
  {
    path: '/login/:errorMsg?',
    name: 'Login',
    component: Login
  },
  {
    path: '/login/:user?',
    name: 'login_user',
    component: Login
  },
  {
    path: '/registrarsenha',
    name: 'RegistrarSenha',
    component: RegistrarSenha
  },
]

export default routes;




// WEBPACK FOOTER //
// ./src/router/auth.js